module.exports = __webpack_public_path__ + "static/img/fwys_pt.2f575ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Virus/Virus/fwys_pt.png
// module id = Lbhi
// module chunks = 16